<div
  #saysoPreviewContainer
  class="container"
  [class.left]="buttonLocation === 'left'"
  [class.right]="buttonLocation === 'right'"
>
  <div class="popup-container">
    <div class="sayso-preview sayso-preview-transition" [class.exited]="!openWebPreview">
      <div class="content">
        <ng-content></ng-content>
        <mat-divider onsip-dotted-divider></mat-divider>
        <div class="sayso-preview-footer">
          @if (!removedOnsipBranding) {
          <p><strong>sayso</strong> {{ "ONSIP_I18N.BY" | translate }} OnSIP</p>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="button-container">
    <div class="label-container" [class.exited]="openWebPreview">
      <div class="label">
        <span>Talk to a real person, right now</span>
      </div>
    </div>
    <button
      mat-fab
      onsip-sayso-fab
      (click)="handleWebClick()"
      [style.background-color]="buttonColor"
      [style.color]="buttonColor | textColorForCustomBackground"
      [class.gradient]="gradientOverlay"
    >
      <mat-icon>{{ openWebPreview ? "close" : "phone" }}</mat-icon>
    </button>
  </div>
</div>
